import React, { useState, useEffect } from "react";
import { useLocation, Link } from "react-router-dom";
import DisplayEnrolledStudentsTable from "./EnrolledStudentsTable";
import { AddStudentsPanel } from "./AddStudent";
import useFetchClasses from "../hooks/useTeacherClasses";
import "./AddStudent.css";

// The Students page: one tab per class, an inline "Add Students" panel (single +
// bulk) for the selected class, the roster table, and a link to the multi-class
// importer. Replaces the old class dropdown.
const DisplayEnrolledStudents = () => {
  const { classList: userClasses } = useFetchClasses();
  // When arriving from a class card, pre-select that class — and open the add
  // panel if it was the "Add Students" button.
  const navState = useLocation().state || {};
  const requestedClassId = navState.classId;
  const [selectedClass, setSelectedClass] = useState("");
  const [showAdd, setShowAdd] = useState(!!navState.openAdd);
  const [refreshKey, setRefreshKey] = useState(0);

  // Default the selection once classes load, and keep it valid if the selected
  // class disappears. Prefer the class passed in from the Classes page.
  useEffect(() => {
    if (!userClasses.length) return;
    const stillExists = userClasses.some((c) => c.id === selectedClass);
    if (!selectedClass || !stillExists) {
      const requestedExists = userClasses.some((c) => c.id === requestedClassId);
      setSelectedClass(requestedExists ? requestedClassId : userClasses[0].id);
    }
  }, [userClasses, selectedClass, requestedClassId]);

  return (
    <div className="add-student-form-container">
      <div className="classes-header" style={{ marginBottom: 12 }}>
        <h1 style={{ margin: 0 }}>Students</h1>
        <Link to="/importclasses">
          <button className="btn-secondary">Import classes + students</button>
        </Link>
      </div>

      {userClasses.length === 0 ? (
        <p style={{ color: "var(--color-secondary)" }}>
          You don't have any classes yet. <Link to="/addclass">Add a class</Link> or{" "}
          <Link to="/importclasses">bulk import classes + students</Link> to get started.
        </p>
      ) : (
        <>
          {/* One tab per class */}
          <div className="as-tabs" style={{ flexWrap: "wrap" }}>
            {userClasses.map((c) => (
              <button
                key={c.id}
                type="button"
                onClick={() => { setSelectedClass(c.id); setShowAdd(false); }}
                className={`as-tab ${selectedClass === c.id ? "active" : ""}`}
              >
                {c.className}
              </button>
            ))}
          </div>

          {selectedClass && (
            <>
              <div style={{ margin: "4px 0 16px" }}>
                <button onClick={() => setShowAdd((s) => !s)}>
                  {showAdd ? "Close" : "+ Add Students"}
                </button>
              </div>

              {showAdd && (
                <div style={{ marginBottom: 24, paddingBottom: 8, borderBottom: "1px solid var(--color-border)" }}>
                  <AddStudentsPanel
                    classId={selectedClass}
                    onDone={() => setRefreshKey((k) => k + 1)}
                  />
                </div>
              )}

              <DisplayEnrolledStudentsTable selectedClass={selectedClass} key={refreshKey} />
            </>
          )}
        </>
      )}
    </div>
  );
};

export default DisplayEnrolledStudents;
